import React from 'react';

const wrapperStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  backgroundColor: '#f0f2f5',
  borderRadius: 12,
  padding: '5px'
};

const baseTabPillStyle = {
  border: 'none',
  backgroundColor: 'transparent',
  color: '#64748b',
  fontWeight: 500,
  fontSize: '0.875rem',
  lineHeight: 1.25,
  padding: '8px 16px',
  borderRadius: 10,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease'
};

const activeTabPillStyle = {
  backgroundColor: '#ffffff',
  color: '#1e293b',
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)'
};

const TeamTabs = ({ tabs = [], activeTab, onTabSelect, className = '', style = {} }) => (
  <div className={className} role="tablist" aria-label="Team management sections" style={{ ...wrapperStyle, ...style }}>
    {tabs.map(tab => {
      const isActive = activeTab === tab.value;
      return (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={isActive}
          tabIndex={0}
          onClick={() => onTabSelect(tab.value)}
          style={{
            ...baseTabPillStyle,
            ...(isActive ? activeTabPillStyle : {})
          }}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default TeamTabs;
